import { PAYMENT_ENDPOINTS } from '../../../utils/api/endpoints/paymentEndpoints';
import { QueryAllSubscriptionsResponse } from './useAllSubscriptions.types';

const PREFIX = '[allSubscriptionsQuery]';

export const queryAllSubscriptions = async () => {
  console.log(PREFIX, `Fetching all user subscriptions...`);
  const response = await PAYMENT_ENDPOINTS.allSubscriptions();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received all user subscriptions.`);
  return json as QueryAllSubscriptionsResponse;
};
